import axios from "axios";

export async function getBioassaysFiltered({ commit }, payload) {
  try {
    const { data } = await axios.get("/bioassays", {
      params: payload,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function addBioassay({ commit }, payload) {
  try {
    const { data } = await axios.post("/bioassays", payload);
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function getProductById({ commit }, payload) {
  try {
    const { data } = await axios.get("/product/get-by-id", {
      params: payload,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function updateBioassay({ commit }, { body, params }) {
  try {
    const { data } = await axios.put("/bioassays", body, {
      params: params,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function finishSettingBioassay({ commit }, { body, params }) {
  try {
    const { data } = await axios.put("/bioassays/finish-settings", body, {
      params: params,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function deleteBioassay({ commit }, payload) {
  try {
    const { data } = await axios.delete("/bioassays", {
      params: payload,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function uploadResultBioassay({ commit }, payload) {
  try {
    const { data } = await axios.put("/bioassays/upload-results", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (data.error) throw data;

    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function deleteResultBioassay({ commit }, { body, params }) {
  try {
    const { data } = await axios.put("/bioassays/delete-results", body, {
      params: params,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function updateTimes({ commit }, { body, params }) {
  try {
    const { data } = await axios.put("/bioassays/update-times", body, {
      params: params,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function updateDnaResult({ commit }, { body, params }) {
  try {
    const { data } = await axios.put("/bioassays/update-dna-result", body, {
      params: params,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function finishResultBioassay({ commit }, { body, params }) {
  try {
    const { data } = await axios.put("/bioassays/finish-result", body, {
      params: params,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function updateTimeResultStage({ commit }, { body, params }) {
  try {
    const { data } = await axios.put(
      "/bioassays/update-time-result-stage",
      body,
      {
        params: params,
      }
    );
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function discardDataResult({ commit }, { body, params }) {
  try {
    const { data } = await axios.put("/bioassays/discard-data-result", body, {
      params: params,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function updateCalibrationStartDate({ commit }, { body, params }) {
  try {
    const { data } = await axios.put("/bioassays/calibration-start", body, {
      params: params,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function updateCalibrationTime({ commit }, { body, params }) {
  try {
    const { data } = await axios.put("/bioassays/calibration-time", body, {
      params: params,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function updateCalibrationEndDate({ commit }, { body, params }) {
  try {
    const { data } = await axios.put("/bioassays/calibration-end", body, {
      params: params,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function finishCalibration({ commit }, { body, params }) {
  try {
    const { data } = await axios.put("/bioassays/calibration-finish", body, {
      params: params,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function setupPackageSend({ commit }, { body, params }) {
  try {
    const { data } = await axios.put("/bioassays/setup-send", body, {
      params: params,
    });
    if (data.error) throw data;
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}